document.addEventListener('DOMContentLoaded', function() {
  function checkPopupVisibility() {
    const popup = document.getElementById('epb_container');
    
    if (popup) {
      const computedStyle = window.getComputedStyle(popup);
      const styleDisplay = popup.style.display;
      
      // Check if popup is hidden (display: none or empty height)
      const isHidden = styleDisplay === 'none' || 
                      computedStyle.display === 'none' || 
                      styleDisplay === '' ||
                      popup.offsetHeight === 0 ||
                      popup.offsetWidth === 0;
      
      const isVisible = !isHidden;
      
      if (isVisible) {
        document.body.classList.add('popup-visible');
      } else {
        document.body.classList.remove('popup-visible');
      }
    } else {
      document.body.classList.remove('popup-visible');
    }
  }
  
  // Check initial state multiple times
  setTimeout(checkPopupVisibility, 100);
  setTimeout(checkPopupVisibility, 500);
  setTimeout(checkPopupVisibility, 1000);
  
  // Monitor for changes in the popup element
  const observer = new MutationObserver(function(mutations) {
    checkPopupVisibility();
  });
  
  // Start observing when popup appears
  const checkForPopup = setInterval(function() {
    const popup = document.getElementById('epb_container');
    if (popup) {
      observer.observe(popup, {
        attributes: true,
        attributeFilter: ['style']
      });
      checkPopupVisibility();
      clearInterval(checkForPopup);
    }
  }, 100);
  
  // Listen for close button clicks
  document.addEventListener('click', function(e) {
    if (e.target.id === 'epb_close' || e.target.closest('#epb_close')) {
      setTimeout(function() {
        checkPopupVisibility();
      }, 100);
    }
  });
  
  // Also listen for any click on the popup background (in case it closes on click)
  document.addEventListener('click', function(e) {
    if (e.target.id === 'epb_background') {
      setTimeout(function() {
        checkPopupVisibility();
      }, 100);
    }
  });
  
  // Periodically check (as fallback)
  setInterval(checkPopupVisibility, 2000);
});